import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Research from "./pages/Research";
import Incubation from "./pages/Incubation";
import Models from "./pages/Models";

function MainLayout({ children }) {
  return (
    <div className="font-body-md text-on-surface overflow-x-hidden">
      <Navbar />
      <main>{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainLayout><Home /></MainLayout>} />
        <Route path="/services" element={<MainLayout><Services /></MainLayout>} />
        <Route path="/research" element={<MainLayout><Research /></MainLayout>} />
        <Route path="/incubation" element={<MainLayout><Incubation /></MainLayout>} />
        <Route path="/models" element={<MainLayout><Models /></MainLayout>} />
      </Routes>
    </Router>
  );
}

export default App;
